import type { ComponentType } from 'react';
import { ExchangeOffersPage } from './ExchangeOffersPage';

/**
 * TEKLIF EKRANLARI — menu kimligi -> bilesen.
 *
 * `src/app/screens.ts` bunlari tek satirla baglar; router'a DOKUNULMAZ.
 *
 * Yalniz BURO tarafi (Tekliflerim). Musterinin ayri "Gelen teklifler" ekrani 2026-10-02'de
 * kaldirildi: musteri teklifleri talebin kendi sayfasinda goruyor (talep merkezli). Eski adresin
 * yonlendirmesi taskExtraRoutes'ta.
 *
 * Bir talebin tekliflerini gosteren detay rotasi burada DEGIL: menude yer
 * almiyor ve `taskExtraRoutes` (src/features/tasks/screens.ts) uzerinden
 * baglaniyor — tum ekstra rotalar tek listede dursun diye.
 */
export const offerScreens: Readonly<Record<string, ComponentType>> = Object.freeze({
  'exchange.offers': ExchangeOffersPage,
});
